import React from "react";
import styled from "styled-components";
import ReactAutocomplete from "react-autocomplete";
import { Error } from "../../service";

const Wrap = styled.div`
  input {
    outline: none;
    appearance: none;
    border-radius: 2px;
    height: 3rem;
    padding: 0.5rem;
    border: 1px solid #dcdcdc;
    display: block;
    width: 100%;
    box-sizing: border-box;
    &:focus {
      border-color: #c7c7c7;
    }
    ${({ isInvalid }) =>
      isInvalid &&
      `
    border-color: #E7040F;
  `};
  }
`;

export default ({ error, onType, ...props }) => (
  <Wrap isInvalid={!!error} {...props}>
    {error && <Error>{error}</Error>}
    <ReactAutocomplete
      {...props}
      onChange={e => {
        props.onChange(e);
        onType(e.target.value);
      }}
      wrapperStyle={{}}
    />
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Autocomplete/index.js